var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.classList,attrs:{"id":"spinner","viewBox":"0 0 100 100"}},[_c('circle',{attrs:{"id":"spinner-inner","cx":"50","cy":"50","r":"45"}})])}
var staticRenderFns = []

export { render, staticRenderFns }